import {ElementRef, Injectable} from '@angular/core'
import {environment} from "../../environments/environment";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EpaasWindow = {epaas?: {api: any}};

@Injectable({
  providedIn: 'root'
})
export class EpaasHelperService {
  public initalizeEpaas(): void {
    if (!environment.load_epaas) {
      console.log('skipping Epaas initialization because it is disabled in the environment');
      return;
    }

    const epaasWindow = (window as EpaasWindow);
    ((epaasWindow?.epaas && epaasWindow?.epaas.api) || window).addEventListener('consentcontroller.api.initialized', (event: unknown) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const typedEvent: {detail: unknown} = event as any;
      if(typedEvent.detail) {
        if (epaasWindow?.epaas && epaasWindow?.epaas.api && epaasWindow.epaas.api.showDisclaimer()) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          epaasWindow?.epaas.api.consentdrawer.then((bundle:unknown) => (bundle as any).showConsentDrawer())
        }
      } else {
        console.error('epaas intialized FAILED');
      }
    });

  }

  public changeLocale(locale: 'en' | 'de'): void {
    const epaasWindow = (window as EpaasWindow);
    if(epaasWindow?.epaas && epaasWindow?.epaas.api) {
      epaasWindow.epaas.api.setLocale(locale);
    }
  }
  public initalizePolicyPage(element: ElementRef): void {
    const epaasWindow = (window as EpaasWindow);
    if (epaasWindow?.epaas && epaasWindow.epaas.api) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      epaasWindow.epaas.api.policypage.then((policypageBundle: unknown) => (policypageBundle as any).showPolicyPage(element.nativeElement));
    }
  }

  public constructor() {}
}
